// My type definitions and enhancements
import './utils/string'
import './utils/date'
import './utils/array'

// Vue application and localization
import { createApp } from 'vue'
import { i18n } from './plugins/i18n'
import { router } from './plugins/router'
import { viewlayer } from './plugins/viewlayer'
import { datalayer } from './plugins/datalayer'
import App from './App.vue'
import ErrorReportDialog from '@/components/dialogs/ErrorReportDialog.vue'
import { Dialog } from 'quasar'

// Application layer initialization
const app = createApp(App)

const reportError = (error: unknown) => {
    console.error(error)
    const err = error as Error | undefined
    Dialog.create({
        component: ErrorReportDialog,
        componentProps: {
            error: err?.stack || err?.message || String(error),
        },
    })
}

app.config.errorHandler = (err) => {
    reportError(err)
}

window.addEventListener('error', (event) => {
    if (event.error) reportError(event.error)
})

window.addEventListener('unhandledrejection', (event) => {
    reportError(event.reason)
})

app.use(i18n)
app.use(datalayer)
app.use(viewlayer)
app.use(router)

// And start application
app.mount('#app')
